import axios from "axios";
import { ApiReturnCodeEnum } from "../enums/api";
import { UtilityService } from '@/utils';
import store from '@/store';

const CancelToken = axios.CancelToken;

// request 攔截器
axios.interceptors.request.use((config) => {
    return config
},
(error) => {
    console.log('request error', error);
    return Promise.reject(error);
})

// response 攔截器
axios.interceptors.response.use((response) => {
    if (response.status == 200) {
        switch (response.data.apiStatus) {
        case ApiReturnCodeEnum.OPERATE_SUCCESS:
            return Promise.resolve(UtilityService.parseAndDecode(response.data.result)); 
        case ApiReturnCodeEnum.NOT_AUTH:
            store.member.mutations.setIsNotAuth(true);
            return Promise.reject({
                data: {
                    apiStatus: ApiReturnCodeEnum.RESPONSE_INTERCEPT
                },
                text: "not auth"
            }); 
        default:
            return Promise.reject(response); 
        }
    } 
    else {
        console.log(`request error, Response = ${response.status}, ReturnCode = ${response.data.apiStatus}`);
        return Promise.reject(response);
    }
},
(error) => {
    if (axios.isCancel(error)) {
        return Promise.reject({
            data: {
                apiStatus: ApiReturnCodeEnum.RESPONSE_INTERCEPT
            },
            text: "cancel request"
        }); 
    } 
    else {
        throw new Error(error);
    }
})

const instance = (method, url, config) => {
    let addition = { cancel: null };
    const request = axios({
        method,
        url,
        baseURL: window.rlServerURL.API,
        withCredentials: true,
        headers: { "Compress-Output": true, "Content-Type": "application/json" },
        cancelToken: new CancelToken(function executor(c) {
            addition.cancel = c;
        }),
        ...config
    })

    request.cancel = () => {
        if (addition.cancel !== null ) {
            addition.cancel();
        }
    }
    
    return request;
};

export default {
    get: (url, config = {}) => instance("get", url, config),
    post: (url, config = {}) => instance("post", url, config),
} 